import { memo } from 'react';

import FeedActionBar from '../FeedActionBar';
import FeedSlideMedia from '../FeedSlideMedia';
import useStyles from './styles';

import type { FeedSlideListProps } from './types';

const VIDEO_PRELOAD_WINDOW = 1;
const POSTER_PRELOAD_WINDOW = 3;
const MEDIA_MOUNT_WINDOW = 5;
const CREDITS_PRELOAD_WINDOW = 2;

const FeedSlideList = ({
  items,
  activeIndex,
  scrollRef,
  setSlideRef,
  isMuted,
  onAudioDetected,
  onUploadTap,
  isUploadDisabled,
  isUploadLoading,
}: FeedSlideListProps) => {
  const classes = useStyles();

  return (
    <div ref={scrollRef} className={classes.scrollArea}>
      {items.map(({ slug, media, type }, index) => {
        const distance = Math.abs(index - activeIndex);
        return (
          <div
            key={slug}
            data-index={index}
            ref={setSlideRef(index)}
            className={classes.slide}
          >
            {distance <= MEDIA_MOUNT_WINDOW && (
              <>
                <FeedSlideMedia
                  media={media}
                  type={type}
                  isActive={index === activeIndex}
                  shouldPreload={distance <= VIDEO_PRELOAD_WINDOW}
                  shouldShowPoster={distance <= POSTER_PRELOAD_WINDOW}
                  index={index}
                  isMuted={isMuted}
                  onAudioDetected={onAudioDetected}
                />
                <div className={classes.slideActionBar}>
                  <FeedActionBar
                    label="Recreate"
                    onUpload={onUploadTap}
                    isDisabled={isUploadDisabled}
                    isLoading={isUploadLoading}
                    slug={slug}
                    shouldLoadCredits={distance <= CREDITS_PRELOAD_WINDOW}
                  />
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default memo(FeedSlideList);
